import { ThinkingOrb } from 'thinking-orbs'
import { cn } from '@/lib/utils'

interface AgentThinkingOrbProps {
  className?: string
  label?: string
}

export function AgentThinkingOrb({
  className,
  label = 'Trabalhando',
}: AgentThinkingOrbProps) {
  return (
    <ThinkingOrb
      state="solving"
      size={20}
      speed={1.75}
      theme="light"
      aria-label={label}
      className={cn(
        'shrink-0 [filter:invert(39%)_sepia(83%)_saturate(2300%)_hue-rotate(241deg)_brightness(94%)_contrast(94%)]',
        className,
      )}
    />
  )
}
